(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    

  /*
   * VERTICAL SCROLL CONTROL
   *
   * Mouse wheel:
   *   Scroll down = next slide
   *   Scroll up   = previous slide
   *
   * Touch:
   *   Swipe up   = next slide
   *   Swipe down = previous slide
   */

  (() => {

    const initVerticalSlideshow = () => {

      const components =
        document.querySelectorAll(
          'layered-slideshow-component'
        );

      components.forEach((component) => {

        if (component.dataset.verticalInitialized) {
          return;
        }

        component.dataset.verticalInitialized = 'true';


        const container =
          component.querySelector(
            '.layered-slideshow__container'
          );

        const tabs =
          Array.from(
            component.querySelectorAll(
              '.layered-slideshow__tablist button'
            )
          );


        if (!container || tabs.length < 2) {
          return;
        }


        let wheelLocked = false;

        let touchStartY = 0;

        let touchStartX = 0;


        /*
         * Find currently active slide
         */

        const getActiveIndex = () => {

          const active =
            tabs.findIndex(
              (tab) =>
                tab.getAttribute(
                  'aria-selected'
                ) === 'true'
            );

          return active >= 0 ? active : 0;
        };


        /*
         * Move to slide
         */

        const moveSlide = (direction) => {

          if (wheelLocked) {
            return;
          }

          const currentIndex =
            getActiveIndex();

          let nextIndex =
            currentIndex + direction;


          /*
           * At the beginning/end, allow the
           * normal page scroll to continue.
           */

          if (
            nextIndex < 0 ||
            nextIndex >= tabs.length
          ) {
            return;
          }


          wheelLocked = true;

          tabs[nextIndex].click();


          setTimeout(() => {
            wheelLocked = false;
          }, 650);
        };


        /*
         * Mouse wheel
         */

        container.addEventListener(
          'wheel',
          (event) => {

            const delta =
              event.deltaY;

            if (Math.abs(delta) < 10) {
              return;
            }


            const currentIndex =
              getActiveIndex();


            /*
             * If we're at the last slide and
             * scrolling down, let the page scroll.
             */

            if (
              delta > 0 &&
              currentIndex === tabs.length - 1
            ) {
              return;
            }


            /*
             * If we're at the first slide and
             * scrolling up, let the page scroll.
             */

            if (
              delta < 0 &&
              currentIndex === 0
            ) {
              return;
            }


            event.preventDefault();

            moveSlide(
              delta > 0 ? 1 : -1
            );

          },
          { passive: false }
        );


        /*
         * Touch start
         */

        container.addEventListener(
          'touchstart',
          (event) => {

            const touch =
              event.touches[0];

            touchStartY =
              touch.clientY;

            touchStartX =
              touch.clientX;

          },
          { passive: true }
        );


        /*
         * Touch end
         */

        container.addEventListener(
          'touchend',
          (event) => {

            const touch =
              event.changedTouches[0];

            const deltaY =
              touchStartY - touch.clientY;

            const deltaX =
              touchStartX - touch.clientX;


            /*
             * Ignore horizontal swipes
             */

            if (
              Math.abs(deltaY) <
              Math.abs(deltaX)
            ) {
              return;
            }


            /*
             * Ignore tiny movements
             */

            if (
              Math.abs(deltaY) < 40
            ) {
              return;
            }


            moveSlide(
              deltaY > 0 ? 1 : -1
            );

          },
          { passive: true }
        );

      });

    };


    /*
     * Run once DOM is ready
     */

    if (
      document.readyState === 'loading'
    ) {

      document.addEventListener(
        'DOMContentLoaded',
        initVerticalSlideshow
      );

    } else {

      initVerticalSlideshow();

    }


    /*
     * Shopify Theme Editor support
     */

    document.addEventListener(
      'shopify:section:load',
      () => {

        setTimeout(
          initVerticalSlideshow,
          100
        );

      }
    );

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
